<template>
  <transition name="fadeslide">
    <div class="modal-mask" v-if="!is_loading">
      <div class="modal-wrapper">
        <div class="modal-container" @click.self="$emit('close')">
          <transition name="ListView" mode="out-in">
            <PagedPublicationTemplate
              v-if="show_buttons"
              :publication="publication"
              :show_page="current_page"
              :key="current_page"
            />
          </transition>
        </div>

        <transition name="fade">
          <button
            class="_nav_left"
            v-if="show_buttons"
            type="button"
            :disabled="current_page <= 1"
            @click="current_page = current_page - 1"
          >
            <svg class="svg-icon" viewBox="0 0 20 20">
              <path
                fill="none"
                d="M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0
	L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109
	c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483
	c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788
	S18.707,9.212,18.271,9.212z"
              />
            </svg>
          </button>
        </transition>
        <transition name="fade">
          <button
            type="button"
            v-if="show_buttons"
            class="_nav_right"
            :disabled="current_page >= publication.pages.length"
            @click="current_page = current_page + 1"
          >
            <svg class="svg-icon" viewBox="0 0 20 20">
              <path
                fill="none"
                d="M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0
	l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109
	c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483
	c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788
	S1.293,9.212,1.729,9.212z"
              />
            </svg>
          </button>
        </transition>

        <div class="modal--navbar">
          <div class>
            <div>{{ publication.name }}</div>
          </div>
          <div class>
            <div>page {{ current_page }} / {{ publication.pages.length }}</div>
          </div>
        </div>
      </div>

      <transition name="fade">
        <button
          type="button"
          v-if="show_buttons"
          class="_close_button"
          @click="$emit('close')"
        >
          <svg class="svg-icon" viewBox="0 0 20 20">
            <path
              fill="none"
              d="M11.469,10l7.08-7.08c0.406-0.406,0.406-1.064,0-1.469c-0.406-0.406-1.063-0.406-1.469,0L10,8.53l-7.081-7.08
							c-0.406-0.406-1.064-0.406-1.469,0c-0.406,0.406-0.406,1.063,0,1.469L8.531,10L1.45,17.081c-0.406,0.406-0.406,1.064,0,1.469
							c0.203,0.203,0.469,0.304,0.735,0.304c0.266,0,0.531-0.101,0.735-0.304L10,11.469l7.08,7.081c0.203,0.203,0.469,0.304,0.735,0.304
							c0.267,0,0.532-0.101,0.735-0.304c0.406-0.406,0.406-1.064,0-1.469L11.469,10z"
            />
          </svg>
        </button>
      </transition>
    </div>
  </transition>
</template>
<script>
import PagedPublicationTemplate from "./PagedPublicationTemplate.vue";
export default {
  props: {
    publication: Object,
  },
  components: {
    PagedPublicationTemplate,
  },
  data() {
    return {
      current_page: 1,
      is_loading: true,
      show_buttons: false,
    };
  },
  created() {
    document.body.style.overflow = "hidden";
    document.addEventListener("keyup", this.modalKeyListener);
  },
  mounted() {
    this.$nextTick(() => {
      this.is_loading = false;

      setTimeout(() => (this.show_buttons = true), 120);
    });
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    document.removeEventListener("keyup", this.modalKeyListener);
  },
  watch: {},
  computed: {},
  methods: {
    modalKeyListener(event) {
      if (event.key === "Escape") {
        this.$emit("close");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;

  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(255, 255, 255, 0.97);
  background-color: rgba(252, 252, 255, 1);
  background-color: hsl(240, 100%, 97%);
  background-color: var(--logo-blue_lighterer);
  // background-color: #333;
  // background-color: rgba(51, 51, 51, 0.97);

  // transition: all 0.2s ease-out;
}

.modal-wrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: 100%;
}

.modal--navbar {
  // position: absolute;
  // bottom: 0;
  // width: 100%;
  box-shadow: 0px 0px 10px -5px var(--logo-blue);
  position: relative;

  > * {
    // border-top: 2px solid var(--logo-blue);

    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: white;

    &:first-child {
      background-color: var(--logo-blue);
      color: white;

      font-weight: 700;
      letter-spacing: 0.02em;
      // font-size: 1.4rem;
    }

    > * {
      margin: calc(var(--spacing) / 2);
      // width: 2em;
      // height: 2em;
    }
  }
}

.modal-container {
  // width: 300px;
  // margin: 0px auto;
  padding: 50px 0;
  height: 100%;
  flex: 1 1 auto;
  overflow-y: scroll;
  // padding: 20px 30px;
  // background-color: #fff;
  border-radius: 2px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  // box-shadow: 0px 4px 2px #999;
}

button {
  box-shadow: 0px 0px 10px -5px var(--logo-blue);

  &:hover,
  &:active,
  &:focus {
    box-shadow: 0px 0px 10px -2px var(--logo-blue);
  }
}

._close_button {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  margin: var(--spacing);
  // background-color: transparent;

  .svg-icon {
    display: block;
  }
}
._nav_left,
._nav_right {
  position: absolute;
  top: 40%;
  padding: calc(var(--spacing));
  margin: calc(var(--spacing));
}
._nav_left {
  left: 0;
}
._nav_right {
  right: 0;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: translateY(5px);
}
</style>
<style lang="scss">
.modal-wrapper {
  .m_pageContainer {
    margin: var(--spacing) auto calc(var(--spacing) * 4);
  }
}
</style>
